__turbopack_context__.v({
  "dataOwnerTop": "EditOwnerFullName-module-scss-module__K01V2W__dataOwnerTop",
  "editFullNameBtn": "EditOwnerFullName-module-scss-module__K01V2W__editFullNameBtn",
  "fullName": "EditOwnerFullName-module-scss-module__K01V2W__fullName",
  "owner-inputs-wrapper": "EditOwnerFullName-module-scss-module__K01V2W__owner-inputs-wrapper",
  "wrapper": "EditOwnerFullName-module-scss-module__K01V2W__wrapper",
});
